import { render, staticRenderFns } from "./o-rating.vue?vue&type=template&id=4cf1b668&scoped=true&"
import script from "./o-rating.vue?vue&type=script&lang=js&"
export * from "./o-rating.vue?vue&type=script&lang=js&"
import style0 from "./o-rating.vue?vue&type=style&index=0&id=4cf1b668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf1b668",
  null
  
)

export default component.exports